import { z } from 'zod';

/** Assistant artwork and voice; independent of human profile, role and project context. */
export const JabberrAvatarId = z.enum(['professional', 'monogram', 'otter', 'businessman', 'businesswoman']);
export type JabberrAvatarId = z.infer<typeof JabberrAvatarId>;
export const DEFAULT_JABBERR_AVATAR: JabberrAvatarId = 'professional';
export const JABBERR_AVATARS = [
  { id: 'professional', label: 'Professional', imageUrl: '/avatars/jabberr-professional.svg' },
  { id: 'monogram', label: 'Monogram', imageUrl: '/avatars/jabberr-monogram.svg' },
  { id: 'businessman', label: 'Businessman', imageUrl: '/avatars/jabberr-businessman.jpg' },
  { id: 'businesswoman', label: 'Businesswoman', imageUrl: '/avatars/jabberr-businesswoman.jpg' },
  { id: 'otter', label: 'Classic otter', imageUrl: '/apple-touch-icon.png' },
] as const;
export const AppearanceRequest = z.object({ jabberrAvatarId: JabberrAvatarId }).strict();
export const AppearanceResponse = z.object({ jabberrAvatarId: JabberrAvatarId, jabberrAssistantImageId: JabberrAvatarId });
export type AppearanceResponse = z.infer<typeof AppearanceResponse>;

/**
 * An appearance as the API returns it. Installed iPhone builds decode `jabberrAvatarId` as a closed set without
 * `businessman`, so that field maps it to `professional`; `jabberrAssistantImageId` carries the real choice.
 */
export function appearanceResponse(id: JabberrAvatarId): { jabberrAvatarId: Exclude<JabberrAvatarId, 'businessman' | 'businesswoman'>; jabberrAssistantImageId: JabberrAvatarId } {
  return { jabberrAvatarId: id === 'businessman' || id === 'businesswoman' ? 'professional' : id, jabberrAssistantImageId: id };
}

/** One canonical voice choice. Legacy artwork and absent/unknown choices retain the male voice. */
export function appearanceVoices(id?: string | null): { professional: 'cedar' | 'marin'; kokoro: 'am_michael' | 'af_heart' } {
  return id === 'businesswoman' ? { professional: 'marin', kokoro: 'af_heart' } : { professional: 'cedar', kokoro: 'am_michael' };
}
